interface ArticleCardProps {
  id: string;
  title: string;
  summary: string;
  author: string;
  date: string;
  category: string;
  imageUrl: string;
  tags: string[];
}

export default function ArticleCard({
  id,
  title,
  summary,
  author,
  date,
  category,
  imageUrl,
  tags,
}: ArticleCardProps) {
  return (
    <a
      href={`/article/${id}`}
      className="group block rounded-lg overflow-hidden bg-background-50 border border-background-200 hover:border-primary-300 transition-all duration-300 cursor-pointer"
    >
      <div className="aspect-[16/9] overflow-hidden">
        <img
          src={imageUrl}
          alt={title}
          title={title}
          className="w-full h-full object-cover group-hover:scale-105 transition-transform duration-500"
        />
      </div>
      <div className="p-4">
        <div className="flex items-center gap-2 mb-2">
          <span className="px-2 py-0.5 text-[10px] font-medium bg-primary-100 text-primary-700 rounded whitespace-nowrap">
            {category}
          </span>
          <span className="text-xs text-foreground-500">{date}</span>
        </div>
        <h3 className="font-heading font-bold text-foreground-900 text-base leading-snug line-clamp-2 group-hover:text-primary-500 transition-colors mb-2">
          {title}
        </h3>
        <p className="text-sm text-foreground-500 leading-relaxed line-clamp-2">
          {summary}
        </p>
        <div className="flex items-center gap-1 mt-3 flex-wrap">
          {tags.slice(0, 3).map((tag) => (
            <span
              key={tag}
              className="px-1.5 py-0.5 text-[10px] text-foreground-500 bg-background-100 rounded whitespace-nowrap"
            >
              #{tag}
            </span>
          ))}
        </div>
      </div>
    </a>
  );
}